var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("table", { staticClass: "table" }, [
        _vm._m(0, false, false),
        _vm._v(" "),
        _c(
          "tbody",
          _vm._l(_vm.maintenanceList, function(maintenance) {
            return _c("tr", [
              _c("td", [_vm._v(_vm._s(maintenance.boxId))]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(maintenance.boxPlaceName))]),
              _vm._v(" "),
              _c("td", {
                staticClass: "comment",
                domProps: { textContent: _vm._s(maintenance.workerComment) }
              }),
              _vm._v(" "),
              _c("td", [
                _c(
                  "button",
                  {
                    staticClass: "btn",
                    on: {
                      click: function($event) {
                        _vm.showWorkerCommentDialog(maintenance.boxId)
                      }
                    }
                  },
                  [_vm._v("\n          編集する\n        ")]
                )
              ])
            ])
          })
        )
      ]),
      _vm._v(" "),
      _c("WorkerCommentDialog", {
        attrs: {
          isShowWorkerCommentDialog: _vm.isShowWorkerCommentDialog,
          btnTitle: "更新",
          isShowCancelBtn: true
        },
        on: {
          close: _vm.closeWorkerCommentDialog,
          cancel: _vm.cancelWorkerCommentDialog
        }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("冷蔵庫ID")]),
        _vm._v(" "),
        _c("th", [_vm._v("会社名-拠点名-フロア")]),
        _vm._v(" "),
        _c("th", [_vm._v("配送員コメント")]),
        _vm._v(" "),
        _c("th")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a2e819c6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a2e819c6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/CommentList.vue
// module id = null
// module chunks = 